import React from "react";
import styles from "../assets/css/slogan.module.scss";
import {Container, Grid, Typography} from "@mui/material";

const Slogan = (props) => {
    return <div className={styles.container}>
        <Container maxWidth={"xl"}>
            <Grid container>
                <Grid item xs={12} md={6}>
                    <Typography variant={"h4"} component={"h4"}>
                        {props.title}
                    </Typography>
                </Grid>
                <Grid item xs={12} md={6}>
                    <Typography variant={"subtitle1"} component={"p"}  style={{textAlign: "justify"}}>
                        {props.description}
                    </Typography>
                </Grid>
            </Grid>
        </Container>
    </div>;
};

export default Slogan;